import { AfterViewInit, Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';
import { NgControl } from '@angular/forms';
import { DecimalPipe } from '@angular/common';

@Directive(
  {
    selector: '[appMoney]',

  },
)
export class MoneyDirective implements AfterViewInit {
  currencyChar = new RegExp('[\,]', 'g');

  constructor(private el: ElementRef, private render: Renderer2, private control: NgControl,
              private decimalPipe: DecimalPipe) {

  }

  ngAfterViewInit() {
    console.log('ejecuta after ', this.el.nativeElement.value);
    if (this.el.nativeElement.value) {
      (this.el.nativeElement as HTMLInputElement).dispatchEvent(new Event('input'));
    }
  }

  @HostListener('input', ['$event']) oninput() {
    const abstracControl = this.control.control;
    let value: string = this.el.nativeElement.value;
    value = value.replace(/[^0-9]*/g, '');
    // tslint:disable-next-line:radix
    const cop = this.decimalPipe.transform(parseInt(value), '1.0', 'en-US');

    value = cop == null ? '' : '$ ' + cop;
    value = value.replace(this.currencyChar, '.');
    // @ts-ignore
    abstracControl.setValue(value.replace(/[^0-9]*/g, ''));
    this.render.setProperty(this.el.nativeElement, 'value', value);

  }

}
